export const BASIC_BLOCK_TYPES = {
  HEADER: 'header',
  EMBED: 'embed',
  LIST: 'list',
  IMAGE: 'image',
  DOCUMENT: 'document',
  TEXT: 'text',
  ACCORDION: 'accordion',
  ACCOMMODATIONS: 'accommodations',
};
